Ext.define('SA.view.RecentListUnselectableLocationCensusReleaseMessage', {
    alias: 'widget.recent-list-unselectable-location-census-release-message',
    extend: 'SA.view.ArrowMenu',

    alignment: 'right',
    baseCls: 'sa-recent-list-unselectable-location-census-release-message',
    closeAction: 'hide',
    floating: true,
    track: true,
    width: 460,

    items: [{
        xtype: 'component',
        cls: 'sa-recent-list-unselectable-location-census-release-message-text',
        itemId: 'popup-text',

        tpl: [
            '<p>',
                'Currently, this side bar is set to display data variables and locations from {start} ',
                '<tpl if="end">',
                    'to {end}',
                '<tpl else>',
                    'and later',
                '</tpl>',
                '. This location is disabled because it is not from these years.',
            '</p>',
            '<p>',
                'To use this location please create a historical view. If you have any questions please ',
                'email <a href="mailto:support@simplyanalytics.com">support@simplyanalytics.com</a>.',
            '</p>'
        ]
    }],

    initComponent() {
        this.callParent();

        this.down('#popup-text').update({start: this.censusRelease, end: this.lastYearInCensusRelease});
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onLinkClick, this, {delegate: 'a'});
    },

    onLinkClick() {
        this.hide();
        this.handler();
    }
});